import { useSelector } from 'react-redux';
import { DataGrid } from '../../components';
import { getLocalized } from '../../redux/localization';
import { productRequestUrl } from '../../services/urls';
import ProductRequestDetailPage from './detail';

function ProductRequestPage() {
    const localize = useSelector(getLocalized);
    const columns = [
        {
            dataField: "Description",
            caption: localize.getString("description"),
        },
        {
            dataField: "ProductCategoryName",
            caption: localize.getString("category"),
        },
        {
            dataField: "Location",
            caption: localize.getString("location"),

        },
        {
            dataField: "UserName",
            caption: localize.getString("username"),
        },
        {
            dataField: "CreateTime",
            caption: localize.getString("creationtime"),
            dataType: "date",
        },
    ];

    return (
        <DataGrid
            getByIdUrl={productRequestUrl}
            url={productRequestUrl}
            columns={columns || []}
            refObject={{}}
            details={{
                width: "30%",
                height: "40%",
                getByIdUrl: "/api/admin/productrequests",
                title: localize.getString("brand-details"),
                component: ProductRequestDetailPage,
            }}
            title="Ürün İstekleri"
        />
    );
}

export default ProductRequestPage;
